<template>
    <div class="md:bg-transparent bg-white flex flex-grow">
        <div class="grid grid-cols-12 items-center h-auto flex-grow">
            <div
                class="md:col-span-6 col-span-12 md:bg-white -my-6 xl:px-28 lg:px-18 md:px-8 sm:px-14 px-5 md:mx-0 -mx-5 lg:py-24 md:py-14 sm:py-10 py-6 md:h-full md:flex md:items-center"
            >
                <div class="form-loader w-full" :class="{ active: isLoadingForm }">
                    <h3 class="leading-8">Selecciona tu método para activar tu membresía</h3>
                    <div class="mt-10">
                        <nav class="grid grid-cols-2 xl:gap-8 md:gap-4 sm:gap-10 gap-4">
                            <a
                                href="#"
                                class="flex items-center justify-center flex-col text-black border-blue-600 lg:text-base md:text-sm sm:text-base text-center border-2 rounded-md shadow-lg font-semibold px-2 py-3"
                            >
                                <strong>Agrega tu tarjeta</strong>
                                <div class="flex items-center xl:mt-3 mt-4 mb-1">
                                    <img
                                        src="/images/amex.png"
                                        class="lg:w-11 md:w-9 sm:w-11 w-10 first:ml-0 md:ml-2 sm:ml-3 ml-2"
                                        alt="Imagen de AMEX"
                                    />
                                    <img
                                        src="/images/visa.png"
                                        class="lg:w-11 md:w-9 sm:w-11 w-10 first:ml-0 md:ml-2 sm:ml-3 ml-2"
                                        alt="Imagen de VISA"
                                    />
                                    <img
                                        src="/images/mastercard.png"
                                        class="lg:w-11 md:w-9 sm:w-11 w-10 first:ml-0 md:ml-2 sm:ml-3 ml-2"
                                        alt="Imagen de MasterCard"
                                    />
                                </div>
                            </a>
                            <a
                                href="#"
                                class="flex items-center justify-center flex-col text-black border-gray-300 opacity-50 hover:opacity-100 hover:border-blue-500 transition duration-300 ease-in-out lg:text-sm md:text-xs sm:text-base text-sm text-center border-2 rounded-md font-semibold px-2 py-2"
                            >
                                <strong>Activa tu membresía física</strong>
                                <div class="flex items-center mt-2">
                                    <img
                                        src="/images/membership.png"
                                        class="xl:h-9 md:h-7 sm:h-8 h-7"
                                        alt="Imagen de membresía física"
                                    />
                                </div>
                            </a>
                        </nav>
                    </div>
                    <div class="mt-8">
                        <label class="text-gray-500">Plan elegido</label>
                        <div class="border border-blue-500 rounded-lg relative py-3 px-6 mt-2">
                            <p class="font-bold">{{ selectedPlan.name }}</p>
                            <a
                                href="#"
                                @click.prevent="planModalIsClosed = false"
                                class="absolute top-0 right-0 py-3 px-6 text-xs text-blue-500 hover:text-blue-700 duration-300 ease-in-out"
                                >Cambiar plan</a
                            >
                            <h2>
                                {{ selectedPlan.presentable_pricing }}
                                <small class="font-normal">{{ selectedPlan.currency }}</small>
                            </h2>
                            <p class="text-sm">Fin de la prueba: {{ selectedPlan.presentable_trial_ends_at }}</p>
                        </div>
                    </div>
                    <form class="mt-10" @submit.prevent="processPayment">
                        <div
                            class="loader-container absolute bottom-0 left-0 right-0 top-0 w-full h-full flex flex-col items-center justify-center overflow-hidden z-2 bg-white opacity-85"
                        >
                            <div class="loader ease-linear rounded-full border-4 border-gray-300 h-12 w-12"></div>
                            <h2 class="text-center text-xl font-semibold mt-6">Cargando...</h2>
                            <p class="text-center">Se está procesando tu transacción</p>
                        </div>
                        <div>
                            <label class="text-gray-500" for="name">Nombre del tarjetahabiente</label>
                            <input
                                class="block w-full py-2 mt-2 leading-5 placeholder-gray-500 transition duration-150 ease-in-out bg-gray-100 border border-gray-200 rounded form-input focus:outline-none focus:placeholder-gray-500 focus:border-red-300 focus:shadow-none sm:text-sm"
                                type="text"
                                name="name"
                                v-model="form.name"
                                placeholder="Escribe el nombre del tarjetahabiente"
                                autocomplete="cc-name"
                                required
                            />
                            <span v-if="errors.name" class="text-red-500 text-sm">{{ errors.name }}</span>
                        </div>
                        <div class="mt-4">
                            <label class="text-gray-500" for="number">Número de tarjeta</label>
                            <div class="flex items-center mt-2">
                                <div
                                    id="card-number-element"
                                    class="block w-full py-2 leading-5 placeholder-gray-500 transition duration-150 ease-in-out bg-gray-100 border border-gray-200 rounded form-input pr-11 focus:outline-none focus:placeholder-gray-500 focus:border-red-300 focus:shadow-none sm:text-sm"
                                ></div>
                                <img
                                    :src="form.brand | toBrandLogo"
                                    class="w-11 ml-4"
                                    alt="Imagen de tarjeta de crédito ó débito"
                                />
                            </div>
                            <span v-if="errors.number" class="text-red-500 text-sm">{{ errors.number }}</span>
                        </div>
                        <div class="mt-4">
                            <div class="grid grid-cols-11 xl:gap-5 lg:gap-3 md:gap-1 sm:gap-5 gap-1">
                                <div class="col-span-6">
                                    <label class="text-gray-500" for="card-expiry-element">Vigencia</label>
                                    <div
                                        id="card-expiry-element"
                                        class="block w-full py-2 mt-2 leading-5 placeholder-gray-500 transition duration-150 ease-in-out bg-gray-100 border border-gray-200 rounded form-input focus:outline-none focus:placeholder-gray-500 focus:border-red-300 focus:shadow-none sm:text-sm"
                                    ></div>
                                    <span v-if="errors.expiry" class="text-red-500 text-sm">{{ errors.expiry }}</span>
                                </div>
                                <div class="col-span-5">
                                    <label class="flex items-center justify-between text-gray-500" for="cvc">
                                        CVV
                                        <div class="flex items-center ml-8 tooltip first:ml-0 z-1">
                                            <div
                                                class="border-2 border-gray-500 flex items-center justify-center rounded-full w-4 h-4"
                                            >
                                                <svg class="w-2 h-2 text-gray-500" viewBox="0 0 50.67 109.48">
                                                    <path
                                                        fill="currentColor"
                                                        stroke="2"
                                                        d="M47.77 96.49l-1.49 6.08q-6.7 2.64-10.69 4a28 28 0 01-9.26 1.38c-5.4 0-9.61-1.33-12.6-4a12.78 12.78 0 01-4.5-10 35 35 0 01.34-4.83c.22-1.65.59-3.5 1.08-5.58l5.58-19.74q.75-2.83 1.26-5.38a23.45 23.45 0 00.5-4.62c0-2.52-.52-4.29-1.56-5.28s-3-1.49-6-1.49a15.51 15.51 0 00-4.44.68c-1.52.45-2.81.88-3.9 1.28l1.53-6.04q5.52-2.24 10.52-3.83a31.37 31.37 0 019.48-1.59q8.06 0 12.42 3.89a12.92 12.92 0 014.36 10.1q0 1.29-.3 4.53a30.63 30.63 0 01-1.12 6l-5.59 19.62a54.34 54.34 0 00-1.25 5.42 28.55 28.55 0 00-.54 4.59q0 3.92 1.75 5.34c1.18 1 3.2 1.42 6.08 1.42a17.56 17.56 0 004.59-.71 26.22 26.22 0 003.75-1.24zm1.37-82.54a11.51 11.51 0 01-3.88 8.76 13.21 13.21 0 01-9.36 3.62 13.34 13.34 0 01-9.4-3.62 11.48 11.48 0 01-3.89-8.76 11.59 11.59 0 013.92-8.8 13.31 13.31 0 019.4-3.65 13.2 13.2 0 019.36 3.65 11.62 11.62 0 013.85 8.8z"
                                                    />
                                                </svg>
                                            </div>
                                            <div class="tooltip-text md:-ml-25 sm:-ml-40 -ml-40 -mt-48">
                                                <div class="px-3 py-3 text-xs text-white bg-black rounded-md">
                                                    <img
                                                        src="/images/tooltip-card.png"
                                                        class="sm:w-48 w-40"
                                                        alt="Imagen informativa del CVV de la tarjeta"
                                                    />
                                                    <svg
                                                        x="0px"
                                                        y="0px"
                                                        viewBox="0 0 255 255"
                                                        class="absolute left-0 md:w-full h-4 text-black mt-3 md:ml-0 ml-40"
                                                    >
                                                        <polygon
                                                            points="0,0 127.5,127.5 255,0"
                                                            class="fill-current"
                                                        ></polygon>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                    <div
                                        id="card-cvc-element"
                                        class="block w-full py-2 mt-2 leading-5 placeholder-gray-500 transition duration-150 ease-in-out bg-gray-100 border border-gray-200 rounded form-input pr-11 focus:outline-none focus:placeholder-gray-500 focus:border-red-300 focus:shadow-none sm:text-sm"
                                    ></div>
                                    <span v-if="errors.cvc" class="text-red-500 text-sm">{{ errors.cvc }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="relative my-8">
                            <div class="flex items-start">
                                <div class="flex items-center h-5">
                                    <input
                                        id="terms"
                                        v-model="form.terms"
                                        name="terms"
                                        type="checkbox"
                                        class="w-4 h-4 text-red-500 transition duration-150 ease-in-out form-checkbox focus:shadow-none"
                                        required
                                    />
                                </div>
                                <div class="ml-3 text-sm leading-5">
                                    <label for="terms" class="text-gray-500"
                                        >Al finalizar aceptas
                                        <a
                                            href="#"
                                            class="text-teal-500 transition duration-300 ease-in-out outline-none hover:text-teal-700"
                                            >Términos y condiciones</a
                                        >
                                        y
                                        <a
                                            href="#"
                                            class="text-teal-500 transition duration-300 ease-in-out outline-none hover:text-teal-700"
                                            >Aviso de privacidad</a
                                        >
                                        de Círculo Plus.</label
                                    >
                                </div>
                            </div>
                            <span v-if="errors.terms" class="text-red-500 text-sm">{{ errors.terms }}</span>
                        </div>
                        <button
                            id="submit-button"
                            type="submit"
                            :disabled="loading"
                            class="btn btn-red block w-full px-10 py-2 mt-8"
                            :class="{ disabled: loading }"
                        >
                            Finalizar y activar mi membresía
                        </button>
                    </form>
                    <div class="flex items-center mt-12">
                        <img src="/images/stripe.png" class="h-8" alt="Logo de Stripe" />
                    </div>
                </div>
            </div>
            <div class="col-span-6 md:block hidden">
                <div class="xl:w-3/4 md:w-4/5 mx-auto py-6">
                    <h2 class="text-teal-500 font-bold text-center lg:text-4xl md:text-2xl">
                        Todos los beneficios exclusivos para ti.
                    </h2>
                    <img src="/images/register.png" class="w-full mt-10" alt="Imagen de registro" />
                    <p class="text-teal-500 xl:px-10 lg:px-7 mt-8">
                        Suscríbete a <strong>Círculo Plus</strong> y recibe descuentos exclusivos en los mejores
                        productos.
                    </p>
                </div>
            </div>
        </div>

        <div id="thankYouModal" class="modal" data-backdrop="true" tabindex="-1">
            <div class="modal-content modal-md">
                <div>
                    <div class="modal-close-container">
                        <button type="button" @click="goToHome" class="modal-close" data-miss="#thankYouModal">
                            <svg
                                width="25"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                                role="img"
                                aria-label="Icono para cerrar mensaje"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-container">
                        <svg
                            class="w-16 mx-auto text-green-600"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 363.76 363.76"
                        >
                            <path
                                fill="currentColor"
                                stroke="10"
                                d="M163.19 260.7a9.42 9.42 0 01-13.32 0h0l-53.22-53.21a14.13 14.13 0 010-20h0l6.68-6.64a14.11 14.11 0 0120 0h0l33.22 33.21 89.74-89.76a14.13 14.13 0 0120 0h0l6.67 6.66a14.12 14.12 0 010 20h0z"
                            />
                            <path
                                fill="currentColor"
                                stroke="10"
                                d="M181.89 361.76C82.7 361.76 2 281.07 2 181.88S82.7 1.96 181.89 1.96s179.88 80.73 179.88 179.92-80.7 179.88-179.88 179.88zm0-325.76C101.45 35.96 36 101.44 36 181.88s65.45 145.88 145.89 145.88 145.88-65.44 145.88-145.88S262.32 35.96 181.89 35.96z"
                            />
                        </svg>
                        <h6 class="text-xl text-center leading-tight mt-5">
                            Felicidades {{ subscription.username }}, tu membresía se activó correctamente
                        </h6>
                        <p class="mt-4">
                            Te enviaremos un correo electrónico de confirmación a
                            <strong>{{ subscription.email }}</strong
                            >, además de un recordatorio 5 días antes de que se realice el cobro.
                        </p>
                        <div class="mt-8">
                            <div class="flex items-center justify-between text-sm first:mt-0 mt-3">
                                <p>Método de pago:</p>
                                <strong class="inline-flex items-center">
                                    <img
                                        :src="subscription.brand | toBrandLogo"
                                        class="w-7 mr-3"
                                        alt="Imagen de tarjeta de crédito ó débito"
                                    />
                                    terminación {{ subscription.lastFourDigits }}
                                </strong>
                            </div>
                            <div class="flex items-center justify-between text-sm first:mt-0 mt-3">
                                <p>Próxima renovación:</p>
                                <strong>
                                    {{ subscription.trialEndsAt }}
                                </strong>
                            </div>
                        </div>
                        <h6 class="text-base text-center mt-8" v-if="benefits.length">
                            Puedes disfrutar de estas promociones y beneficios desde este momento.
                        </h6>
                        <div class="grid grid-cols-3 sm:gap-3 gap-2 mt-6" v-if="benefits.length">
                            <div class="col-span-1 bg-white relative rounded-md" v-for="benefit in benefits">
                                <img :src="benefit.image" class="w-full rounded-md" :alt="benefit.title" />
                                <p class="text-xs text-gray-600 font-bold truncate mt-1">{{ benefit.title }}</p>
                                <a :href="benefit.link" class="absolute bottom-0 left-0 right-0 top-0"></a>
                            </div>
                        </div>
                        <div class="flex justify-center mt-6">
                            <a href="/mi-cuenta" class="btn btn-red inline-block px-12 py-3">Ir a mi cuenta</a>
                        </div>
                        <div class="mt-5">
                            <p class="text-xs text-center">
                                <span class="mr-2px"
                                    >Comunícate al centro de atención a clientes:
                                    <a
                                        href="tel:5555406843"
                                        class="inline-block text-blue-500 hover:text-blue-700 outline-none transition duration-300 ease-in-out underline"
                                        >55 5540 6843</a
                                    >
                                    de lunes a sábado de 9:00 a 21:00 horas y domingo de 9:00 a 20:00 horas (tiempo del
                                    Centro), para cualquier aclaración.</span
                                >
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop"></div>
        </div>
        <register-plan-modal
            v-if="!planModalIsClosed"
            @bubbleUpSelectedPlan="planWasSelected"
            @closePlanModal="planModalIsClosed"
        ></register-plan-modal>
    </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { nextPaymentDay, toBrandLogo } from '../filters';
import RegisterPlanModal from './RegisterPlanModal';
import sweetAlert from 'sweetalert2';
const modal = require('../support/Modal');

export default {
    name: 'Subscription',

    components: {
        RegisterPlanModal,
    },

    computed: {
        selectedPlan() {
            return this.form.plan ?? this.plan;
        },
    },

    props: ['plan', 'username'],

    filters: {
        toBrandLogo,
    },

    data() {
        return {
            stripe: null,
            loading: false,
            isLoadingForm: false,
            cardNumberElement: null,
            cardExpiryElement: null,
            cardCvcElement: null,
            form: {
                name: '',
                brand: '',
                token_id: '',
                terms: false,
                plan: null,
                plan_id: null,
            },
            errors: {
                name: '',
                number: '',
                expiry: '',
                cvc: '',
                terms: '',
            },
            options: {
                classes: {
                    focus: 'border-red-300',
                },
                style: {
                    base: {
                        fontSize: '14px',
                        fontFamily: 'Mulish, inherit',
                    },
                },
            },
            planModalIsClosed: true,
            subscription: {},
            benefits: {},
        };
    },

    mounted() {
        this.setupStripe();
    },

    methods: {
        async setupStripe() {
            this.stripe = await loadStripe($('meta[name="stripe-key"]').attr('content'), {
                locale: 'es',
            });

            this.createAndMountElements();
        },

        createAndMountElements() {
            const elements = this.stripe.elements();

            this.cardNumberElement = elements.create('cardNumber', this.options);
            this.cardNumberElement.mount('#card-number-element');

            this.cardExpiryElement = elements.create('cardExpiry', this.options);
            this.cardExpiryElement.mount('#card-expiry-element');

            this.cardCvcElement = elements.create('cardCvc', this.options);
            this.cardCvcElement.mount('#card-cvc-element');

            this.cardNumberElement.on('change', (event) => {
                this.form.brand = event.brand;
                this.errors.number = event.error ? event.error.message : '';
            });
            this.cardExpiryElement.on(
                'change',
                (event) => (this.errors.expiry = event.error ? event.error.message : '')
            );
            this.cardCvcElement.on('change', (event) => (this.errors.cvc = event.error ? event.error.message : ''));
        },

        planWasSelected(plan) {
            this.form.plan = plan;
            this.closePlanModal();
        },

        closePlanModal() {
            $('body, html').removeClass('overflow-hidden');
            this.planModalIsClosed = true;
        },

        processPayment() {
            this.loading = true;
            this.isLoadingForm = true;

            if (this.checkForm()) {
                this.stripe
                    .createToken(this.cardNumberElement, {
                        name: this.form.name,
                        currency: 'MXN',
                    })
                    .then((result) => {
                        if (result.error) {
                            this.loading = false;
                            this.isLoadingForm = false;
                            sweetAlert.fire('Error', result.error.message, 'error');
                        } else {
                            this.form.token_id = result.token.id;
                            this.form.plan_id = this.selectedPlan.id;

                            axios
                                .post('/suscripcion', this.form)
                                .then((response) => {
                                    this.isLoadingForm = false;
                                    this.subscription = response.data.subscription;
                                    this.benefits = response.data.benefits;
                                    modal.trigger($('#thankYouModal'));
                                })
                                .catch((error) => {
                                    this.loading = false;
                                    this.isLoadingForm = false;

                                    let errors = error.response.data.errors;

                                    if (errors.name) {
                                        this.errors.name = errors.name['0'];
                                    }

                                    sweetAlert.fire('Error', 'Verifica tus datos.', 'error');
                                });
                        }
                    });
            }
        },

        goToHome() {
            window.location.href = '/';
        },

        checkForm() {
            if (this.form.name && this.form.terms) {
                return true;
            }

            if (!this.form.name) {
                this.errors.name = 'El campo nombre del tarjetahabiente es requerido.';
                this.loading = false;
                this.isLoadingForm = false;
            }
            if (!this.form.terms) {
                this.errors.terms = 'El campo términos y condiciones es requerido.';
                this.loading = false;
                this.isLoadingForm = false;
            }

            return false;
        },
    },
};
</script>
